import { Variables } from '../../variables/variables';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { IMaskInput } from 'react-imask';
import type { ComponentType } from 'react';

export interface IPhoneInputProps {
    showSuccess?: boolean;
    showError?: boolean;
    showDelete?: boolean;
}

type StyledMaskInputProps = IPhoneInputProps & Record<string, unknown>;

const successInputState = css`
    --input-border-color: ${Variables.Colors.successful};
    &:not(:disabled) {
        &:hover {
            --input-border-color: ${Variables.Colors.successful};
        }

        &:focus,
        &:active {
            --input-border-color: ${Variables.Colors.successful};

            box-shadow: 0 0 0 3px rgba(112, 212, 190, 0.24);
        }
    }
`;

const errorInputState = css`
    --input-border-color: ${Variables.Colors.warning};
    &:not(:disabled) {
        &:hover {
            --input-border-color: ${Variables.Colors.warning};
        }

        &:focus,
        &:active {
            --input-border-color: ${Variables.Colors.warning};

            box-shadow: 0 0 0 3px rgba(242, 93, 102, 0.24);
        }
    }
`;

const deleteInputState = css`
    padding-right: 40px;
`;

const phoneStyleProps = new Set(['showSuccess', 'showError', 'showDelete']);

export const StyledMaskInput: ComponentType<StyledMaskInputProps> = styled(IMaskInput, {
    shouldForwardProp: prop => !phoneStyleProps.has(String(prop)),
})<IPhoneInputProps>`
    --input-color: ${Variables.Colors.n100};
    --input-border-color: ${Variables.Colors.nx8};
    --input-background-color: ${Variables.Colors.white};

    display: block;
    border-radius: ${Variables.Rounded.small};
    border: solid 1px;
    border-color: var(--input-border-color);
    height: 40px;
    width: 100%;
    padding: 0 8px;
    box-sizing: border-box;
    background-color: var(--input-background-color);
    color: var(--input-color);
    font-size: 16px;
    transition: ${Variables.transition};
    &::placeholder {
        color: ${Variables.Colors.n15};
        font-size: 14px;
    }

    &:not(:disabled) {
        &:hover {
            --input-border-color: ${Variables.Colors.b400};
        }

        &:focus,
        &:active {
            --input-border-color: ${Variables.Colors.b500};

            box-shadow: 0 0 0 3px rgba(30, 87, 207, 0.16);
            outline: 0;
        }
    }

    ${props => {
        if (props.showSuccess) {
            return successInputState;
        }

        if (props.showError) {
            return errorInputState;
        }

        if (props.showDelete) {
            return deleteInputState;
        }

        return;
    }}

    &:disabled {
        --input-background-color: ${Variables.Colors.nx4};
    }

    &:read-only {
        cursor: pointer;
    }
`;
